<template>
  <dialog-remainder-table ref="dialog" :title="title" :companyID="companyID" :tableConfig="config" />
</template>

<script>

import { toDate, toPriceCurrency } from '@/utils/filters'
export default {
  name: 'rfq-pending__dialog-remainder-table',
  components: {
    'dialog-remainder-table': () => import(/* webpackChunkName: 'DialogRemainderTable' */ '@/components/dialog-remainder-table')
  },
  props: {
    title: {
      required: true
    },
    companyID: {
      required: true
    }
  },
  computed: {
    config () {
      return [
        {
          field: 'invoiceNumber',
          labelKey: 'invoice-number',
          sortable: true
        },
        {
          field: 'invoice.po',
          labelKey: 'po',
          sortable: true,
          template: (data) => (data.invoice && data.invoice.po) || '--'
        },
        {
          field: 'invoiceDate',
          labelKey: 'invoice-date',
          convertor: (v, data) => toDate(v),
          excelType: 'd'
        },
        {
          field: 'invoiceAmount',
          labelKey: 'invoice-amount',
          convertor: (v, data) => toPriceCurrency(v, data.currency.title),
          sortable: true
        },
        {
          field: 'invoiceDueDate',
          labelKey: 'invoice-due-date',
          convertor: (v, data) => toDate(v),
          excelType: 'd'
        }
      ]
    }
  },
  methods: {
    show () {
      this.$refs['dialog'].show()
      this.loadData()
    }
  }
}
</script>
